import { render } from "./registrations.vue?vue&type=template&id=6c141474&scoped=true"
import script from "./registrations.vue?vue&type=script&lang=js"
export * from "./registrations.vue?vue&type=script&lang=js"

import "./registrations.vue?vue&type=style&index=0&id=6c141474&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c141474"]])

export default __exports__